import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography, Grid,
} from '@material-ui/core';
import NotificationBar from '@trdk/style/NotificationBar';
import { connect } from 'react-redux';
import * as yup from 'yup';
import { doFetch, fetchClear } from '../../../services/fetch/fetch.actions';
import { fetchClear as fetchClearUsers } from './users.actions';
import DefaultForm from '../../../components/default-form';
import RoleSelection from '../../../components/role-selection';
import UserForm from '../../../components/user-form';
import { putUser } from '../../../services/admin/user-service';
import { fetchRole } from '../../../services/politician/profile-service';

const schema = yup.object().shape({
  fnr: yup.string().matches(/^[0-9]{11}$/, 'Fødselsnummer må være 11 siffer').required('Fødselsnummer er påkrevd'),
  epost: yup.string().email().required('Epost påkrevd'),
  fornavn: yup.string().required('Fornavn er påkrevd'),
  etternavn: yup.string().required('Etternavn er påkrevd'),
  adresse: yup.string().required('Adresse påkrevd'),
  parti: yup.string().required('Parti påkrevd'),
  gender: yup.string().required('Kjønn påkrevd'),
  postnr: yup.number().typeError('Kan ikke inneholde tekst').required('Postnummer påkrevd'),
  poststed: yup.string().required('Poststed påkrevd'),
  tlfprivat: yup.string().matches(/^[0-9]{1,8}$/, 'Telefonnummer ikke gyldig').required('Telefonnummer påkrevd'),
  arbeidssted: yup.string(),
  bankkontonummer: yup.number().required('Bankkontonr. påkrevd'),
  generalInfo: yup.string(),
});

const roles = [
  'politician',
  'admin',
  'superadmin',
  'secretary',
  'observer',
  'other',
];

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localError: undefined,
      chosenRoles: ['politician'],
    };
  }

  componentDidMount() {
    const {
      dispatch,
      me: { fetched: meFetched, fetching: meFetching },
    } = this.props;

    if (!meFetched && !meFetching) {
      dispatch(doFetch('ME', fetchRole()
        .then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          return res.json();
        })));
    }
  }

  handleSubmit = (values) => {
    const { dispatch, history } = this.props;
    const { chosenRoles } = this.state;

    let parties = [];
    if (chosenRoles.includes('politician')) {
      parties = [{
        id: values.parti,
      }];
    }

    dispatch(doFetch(
      'ADD_USER',
      putUser({
        ssn: values.fnr,
        active: 1,
        givenName: values.fornavn,
        familyName: values.etternavn,
        email: values.epost,
        phone: values.tlfprivat,
        roles: chosenRoles,
        sex: values.gender === 'Kvinne' ? 'f' : 'm',
        streetAddress: values.adresse,
        zipCode: values.postnr,
        city: values.poststed,
        workPlace: values.arbeidssted,
        bankAccount: values.bankkontonummer,
        generalInfo: values.generalInfo,
        parties: parties.length > 0 ? parties : undefined,
      })
        .then((res) => {
          if (!res.ok) {
            res.json().then(data => this.setState({ localError: data.error }));
            throw res.statusText;
          }
          return res;
        })
        .then(() => {
          dispatch(fetchClearUsers());
          dispatch(fetchClear('ADD_PARTY'));
          dispatch(fetchClear('PARTIES'));
          history.push('/admin');
        }),
    ));
  }

  render() {
    const {
      classes, addUser: { fetched, error: fetchError },
      me: { fetched: meFetched, payload: me },
    } = this.props;
    const { localError, chosenRoles } = this.state;

    return (
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.mb} color="primary">Legg til ny bruker</Typography>
          </Grid>
          {meFetched && (
            <RoleSelection
              roles={me.roles.includes('superadmin') ? roles : [
                'politician', 'secretary', 'observer', 'other']}
              chosenRoles={chosenRoles}
              onChange={v => (
                this.setState({
                  // eslint-disable-next-line no-nested-ternary
                  chosenRoles: v.target.value.length === 0 ? chosenRoles : (
                    v.target.value.indexOf('other') > 0
                      ? ['other'] : v.target.value.filter(e => e !== 'other')
                  ),
                })
              )}
            />
          )}
        </Grid>
        {chosenRoles.includes('politician') ? (
          <DefaultForm
            schema={schema}
            onSubmit={this.handleSubmit}
            requiredFields
            initialValues={{
              parti: '',
              fnr: '',
              fornavn: '',
              etternavn: '',
              adresse: '',
              gender: '',
              postnr: '',
              poststed: '',
              tlfprivat: '',
              arbeidssted: '',
              epost: '',
              bankkontonummer: '',
              generalInfo: '',
            }}
            isAdmin
          />
        ) : (
          <UserForm
            initialValues={{
              fornavn: '', etternavn: '', fnr: '', epost: '', tlfprivat: '',
            }}
            handleSubmit={this.handleSubmit}
            requiredField
          />
        )}
        {
          /* TODO: Fikse denne. Gir ikke feilmelding ved 409. */
          localError === 'Conflict' && <NotificationBar message="Fødselsnummeret er registrert på en annen politiker" variant="error" />
        }

        {

          fetched && fetchError && localError !== 'Conflict' && (
            <NotificationBar message="Feil ved innsending" variant="error" />
          )
        }

      </div>
    );
  }
}

const styles = theme => ({
  submit: {
    width: '100%',
    marginTop: '2rem',
  },
  form: {
    marginTop: '1rem',
    flexGrow: 1,
  },
  root: {
    marginBottom: '4rem',
    maxWidth: '60rem',
  },
  cancel: {
    color: '#fff',
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
    width: '100%',
    marginTop: '2rem',
  },
  gridItem: {
    paddingLeft: '0.8rem',
  },
  formControl: {
    width: '100%',
  },
});

AddUser.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.any.isRequired,
  addUser: PropTypes.object.isRequired,
  me: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = ({ addUser, me }) => ({ addUser, me });

export default connect(mapStateToProps)(withRouter(withStyles(styles)(AddUser)));
